export default __webpack_public_path__ + "static/media/toLeft.06c35bd0.svg";